import React from 'react';
import { TherapyProductInfo } from '../TherapyProductInfo';

type ShowAlertByProductProps = {
  productName?: string;
};

function includes(name: string, comparison: string) {
  return name.toLocaleLowerCase().includes(comparison.toLocaleLowerCase());
}

export const ShowAlertByProduct: React.FC<ShowAlertByProductProps> = ({ productName }) => {
  if (productName) {
    if (includes(productName, 'sangria')) return <TherapyProductInfo />;
  }
  return null;
};
